var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelectIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5l.544-.479L9 1.057 7.912 0 4.5 2.989 1.088 0 0 1.057l3.956 3.464L4.5 5z",
    fill: "#085FE5"
  })));
}

export default SvgSelectIcon;